import styled from "@emotion/styled";

export const Button = styled.button({
  background: "none",
  border: "none",
});
